var map = {
	"./en/admin.json": 81739,
	"./en/clinic.json": 94453,
	"./en/common.json": 34010,
	"./en/company.json": 70989,
	"./en/screen.json": 46660,
	"./ms/admin.json": 90252,
	"./ms/clinic.json": 70692,
	"./ms/common.json": 97550,
	"./ms/company.json": 27502,
	"./ms/screen.json": 75325
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68262;